// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OTilie Answer Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SystemPromptUpdateRequest
 */
export interface SystemPromptUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof SystemPromptUpdateRequest
     */
    prompt: string;
}

/**
 * Check if a given object implements the SystemPromptUpdateRequest interface.
 */
export function instanceOfSystemPromptUpdateRequest(value: object): value is SystemPromptUpdateRequest {
    if (!('prompt' in value) || value['prompt'] === undefined) return false;
    return true;
}

export function SystemPromptUpdateRequestFromJSON(json: any): SystemPromptUpdateRequest {
    return SystemPromptUpdateRequestFromJSONTyped(json, false);
}

export function SystemPromptUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemPromptUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'prompt': json['prompt'],
    };
}

export function SystemPromptUpdateRequestToJSON(json: any): SystemPromptUpdateRequest {
    return SystemPromptUpdateRequestToJSONTyped(json, false);
}

export function SystemPromptUpdateRequestToJSONTyped(value?: SystemPromptUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'prompt': value['prompt'],
    };
}

